<template>
<LayoutContainer columns="100">
<v-toolbar slot="header" dark class="primary no-print">
    <v-toolbar-title>{{pageTitle}}</v-toolbar-title>   
    <v-spacer />
    <v-menu offset-y>
        <template v-slot:activator="{ on }">
            <v-icon v-on="on">more_vert</v-icon>
        </template>
        <v-list>
            <v-list-item @click="notifyChangesMenuClicked">
                <v-list-item-title>Notify Office of Changes</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu> 
</v-toolbar>

<div slot="col1" >
    <div v-if="checklistKey" class="pa-3">  
        <ChecklistDetails :pageSettings="pageSettings" :checklistKey="checklistKey" mode="Client" @change="documentChanged" />
        <div class="small-text light-text">Click on a document to upload files or see more information</div>
    </div>
    <template v-else>
        <NoRecordsPlaceholder message="No checklist specified"/>
    </template>
</div>

<!--Dialog-->

<template slot="dialogs">
        
    <AdvancedDialog :record="addDocumentDialog.record" :settings="addDocumentDialog.settings" :fields="addDocumentDialog.fields" @save="saveDocumentForCategory" />

</template>

</LayoutContainer>
</template>

<script>
import LayoutContainer from '@/ui-elements/LayoutContainer'
import StringHelpers from '../../helpers/StringHelpers'
import TemplateHelpers from '../../helpers/TemplateHelpers'
import DataHelpers from '../../helpers/DataHelpers'
import ContactHelpers from '../../helpers/ContactHelpers'
import AlertHelpers from '@/helpers/AlertHelpers'
import NiceData from '../../data/NiceData'
import ChecklistDetails from './ChecklistDetails'
import ChecklistHelpers from './ChecklistHelpers'
import MergeHelpers from '../../helpers/MergeHelpers'
import EmailHelpers from '../../helpers/EmailHelpers'
import AdvancedList from '../../ui-elements/AdvancedList'
import AdvancedPanel from '../../ui-elements/AdvancedPanel'
import AdvancedDialog from '../../ui-elements/AdvancedDialog'
import NoRecordsPlaceholder from '../../ui-elements/NoRecordsPlaceholder'
import Utilities from '../../helpers/Utilities';

export default {
    name: 'ClientChecklist',
    props: {
            checklistKey: String
    }, 

    components: {
        LayoutContainer,
        ChecklistDetails,
        AdvancedList,
        AdvancedPanel,
        AdvancedDialog,
        NoRecordsPlaceholder,
    },
    data() {
        return {
            transactionDetails: {},
            checklistDetails: {},
      //      search: '',


            checklistTable: {
                ref: null,
                fields: [
                    {name: 'name', type: 'Text'},
                    {name: 'templates', type: 'List'},
                    {name: 'template', type: 'Switch',},
                    {name: 'global', type: 'Switch'},
                    {name: 'stamp', type: 'Text', default: '[stamp]'},
                    {name: 'tenantKey', type: 'Text', default: '[tenantKey]'},
                ],
            },

            checklistDetailsPanel: {
                fields: [
                    {name: 'name', title: 'Template Name', type: 'Text'},
                    {name: 'advanced', title: 'Show Advanced Options', type: 'Switch', width:70},
                    {name: 'done', title: 'Done', type: 'Button', width:30},
                    {name: 'template', title: 'Template', type: 'Switch', visibleFilter: '[advanced] = true', disabled:true},
                    {name: 'global', title: 'Global', type: 'Switch', visibleFilter: '[template] = true && [advanced] = true'},
                    {name: 'makeCopy', title: 'Make a Copy', type: 'Button', visibleFilter: '[advanced] = true', width:50},
                    {name: 'deleteTemplate', title: 'Delete Template', type: 'Button', color:'error', visibleFilter: '[advanced] = true', width:50},
                ],
                settings: {},
            },

            addDocumentDialog: {
                record: {},
                settings: {
                    visible: false
                },
                fields: [], 
            },

            addDocumentFields: [
                {name: 'name', title: 'Name', type: 'Text', focus: true},
                {name: 'checks', title: 'Things to Check', type: 'Group', fields: [
                    {name: 'check', title: 'Please Check', type: 'Text', width:70},
                ]},
            ],
            
        }
    },
     
    computed: {

        topRef() {
            return DataHelpers.getRootRef().child('app/documentChecklist')
        },
        listRef() {
            return this.topRef.child('list')
        },
        listItemRef() {
            return this.listRef.child(this.checklistKey)
        },
        dataRef() {
            return this.topRef.child('data').child(this.checklistKey)
        },
        pageTitle() {
            return this.transactionDetails.clients || 'Document Checklist'
        },
        pageSettings() {
            return {
                flagOutstandings: this.checklistDetails.flagOutstandings
            }
        },
        tenantKey() {
            return this.checklistDetails.tenantKey || null
        },
        hasTransaction() {
            return (Object.keys(this.transactionDetails).length > 0)
        }

    },  
    methods: {

        notifyChangesMenuClicked() {
            this.sendEmailOfChanges()
        },

        selectTemplate(template) {
            this.goToTemplate(template.meta.key)
        },

        async checklistDetailsButton(buttonName, record) {
            if(buttonName == 'makeCopy') {
                let newKey = DataHelpers.getKey()
                NiceData.copyItems(this.dataRef.child('categories'), this.topRef.child('data').child(newKey).child('categories'))
                NiceData.copyItems(this.dataRef.child('policies'), this.topRef.child('data').child(newKey).child('policies'))
                NiceData.copyItems(this.dataRef.child('options'), this.topRef.child('data').child(newKey).child('options'))
                NiceData.copyItems(this.dataRef.child('documents'), this.topRef.child('data').child(newKey).child('documents'))
                
                let newDetails = {...this.checklistDetails}
                newDetails.name += ' (copy)'
                newDetails.advanced = null
                
                newDetails.meta.key = newKey
                NiceData.saveItem(newDetails)
                this.goToTemplate(newKey)
            }

            if(buttonName == 'deleteTemplate') {
                if(await this.$root.$confirm('Delete', 'Delete this template?', { color: 'red' }) == true) {

                    ChecklistHelpers.deleteChecklist(record.meta.key)
                    this.loadTemplates()
                    this.$router.push('/' + this.tenantKey + '/checklist-templates')
                }
            }

        },


        checklistDetailsFieldChanged(changes) {

        },

        categoryClicked(category) {
            let categoryName = category.name
        },

        addDocumentForCategory(categoryName) {
            console.log('addDocumentForCategory', categoryName)
            this.addDocumentDialog.fields = this.addDocumentFields
            this.addDocumentDialog.record = {}
            this.addDocumentDialog.settings.visible = true
        },

        saveDocumentForCategory(document) {
            console.log('saveDocumentForCategory', document)
            this.sendEmailOfChanges()
        },

        documentChanged(document) {
            this.sendEmailOfChanges()
        },
        
        sendEmailOfChanges() {

            console.log('Sending email of changes')

            Utilities.checkIfThisWasDone('checklist-notification-' + this.checklistKey).then(done => {
                if(done) {
                    console.log('skipping...already sent')
                    return
                }

                ChecklistHelpers.fetchChecklistTask(this.tenantKey, this.checklistKey).then(task => {


                    if(!task || !task.assigned || !task.assigned.email) {
                        console.log('Cant send email, nobody assigned')
                        return
                    }
                    const recipient = task.assigned.email
                    const greeting = task.assigned.firstName

                    TemplateHelpers.fetchTemplate('global', 'Notify Checklist Updated').then(template => {


                        console.log('Template is ', template)

                        if(!template) {
                            AlertHelpers.showAlert('Template not found: Notify Checklist Updated')
                            return
                        }

                        let linkToTaco = StringHelpers.linkToTaco( this.checklistDetails.tenantKey +  '/document-checklist/' + this.checklistKey, 'Go there now')

                        let customFields = {
                            greeting,
                            sender: this.$store.getters.user.firstName,
                            clients: this.transactionDetails.clients,
                            transaction_link: linkToTaco,
                        }

                        let body = MergeHelpers.simpleMerge(template.body, customFields)

                        let email = {}
                        email.from = 'no-reply@insightprocessing.com.au'
                        email.fromName = 'Taco System Alert'
                        email.to = recipient
                        email.subject = template.subject || ''
                        email.body = body
                        EmailHelpers.sendEmail(email)
                        console.log('Email Sent')
                    })
                })
            })           
                
        }, 

        loadDetails() {
            this.checklistTable.ref = DataHelpers.getRootRef().child('app/documentChecklist/list')
            let ref = this.checklistTable.ref.child(this.checklistKey)

            NiceData.fetchItemSingle(ref).then( (item) => {
                if(!item)  {
                    AlertHelpers.showAlert('Checklist not found')
                    return
                }
                this.checklistDetails = item
                
                let transactionRef = DataHelpers.getRootRef().child('tenants').child(this.tenantKey)
                    .child('transactions').child(this.checklistKey).child('details')
        
                NiceData.fetchItemSingle(transactionRef).then(transactionDetails => {
                    if(transactionDetails)
                        this.transactionDetails = transactionDetails
                })
            })

        }            

    },

    beforeDestroy() {
       
    },

    watch: {
        'checklistKey': {
            handler: function(newVal, oldVal) {
                if(newVal)
                    this.loadDetails()
            },
            immediate: true
        }
    },

    created () {
        document.title = 'Document Checklist'
    }
}

</script>

<style scoped>


</style>


// WEBPACK FOOTER //
// ClientChecklist.vue?f359c814